const MODULE_NAME = "oncall/";

export const SETTINGS_PAGE_LOAD = `@@${MODULE_NAME}SETTINGS_PAGE_LOAD`;
export const SETTINGS_LOADED = `@@${MODULE_NAME}SETTINGS_LOADED`;
export const SETTINGS_UPDATE_REQUEST = `@@${MODULE_NAME}SETTINGS_UPDATE_REQUEST`;
export const SETTINGS_UPDATE_ERROR = `@@${MODULE_NAME}SETTINGS_UPDATE_ERROR`;
export const SETTINGS_UPDATED = `@@${MODULE_NAME}SETTINGS_UPDATED`;

//add email for global settings
export const SETTINGS_EMAIL_ADD_REQUEST = `@@${MODULE_NAME}SETTINGS_EMAIL_ADD_REQUEST`;
export const SETTINGS_EMAIL_ADD_ERROR = `@@${MODULE_NAME}SETTINGS_EMAIL_ADD_ERROR`;
export const SETTINGS_EMAIL_ADDED = `@@${MODULE_NAME}SETTINGS_EMAIL_ADDED`;
export const SETTINGS_EMAIL_DELETE_REQUEST = `@@${MODULE_NAME}SETTINGS_EMAIL_DELETE_REQUEST`;
export const SETTINGS_EMAIL_DELETE_ERROR = `@@${MODULE_NAME}SETTINGS_EMAIL_DELETE_ERROR`;
export const SETTINGS_EMAIL_DELETED = `@@${MODULE_NAME}SETTINGS_EMAIL_DELETED`;

// Creators
export const settingsPageLoad = () => ({
  type: SETTINGS_PAGE_LOAD,
  payload: {},
});

export const settingsLoaded = globalSettings => ({
  type: SETTINGS_LOADED,
  payload: {
    globalSettings,
  },
});
export const settingsUpdateRequest = formData => ({
  type: SETTINGS_UPDATE_REQUEST,
  payload: {
    formData,
  },
});
export const settingsUpdateError = message => ({
  type: SETTINGS_UPDATE_ERROR,
  payload: {
    message,
  },
});
export const settingsUpdated = () => ({
  type: SETTINGS_UPDATED,
  payload: {},
});
export const settingsEmailAddRequest = email => ({
  type: SETTINGS_EMAIL_ADD_REQUEST,
  payload: {
    email,
  },
});
export const settingsEmailAddError = message => ({
  type: SETTINGS_EMAIL_ADD_ERROR,
  payload: {
    message,
  },
});
export const settingsEmailAdded = email => ({
  type: SETTINGS_EMAIL_ADDED,
  payload: {
    email,
  },
});
export const settingsEmailDeleteRequest = email => ({
  type: SETTINGS_EMAIL_DELETE_REQUEST,
  payload: {
    email,
  },
});
export const settingsEmailDeleteError = email => ({
  type: SETTINGS_EMAIL_DELETE_ERROR,
  payload: {
    email,
  },
});
export const settingsEmailDeleted = email => ({
  type: SETTINGS_EMAIL_DELETED,
  payload: {
    email,
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/global-settings.js